import { render, staticRenderFns } from "./BetterpayConfirmationDialog.vue?vue&type=template&id=a8c9969c&scoped=true"
import script from "./BetterpayConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./BetterpayConfirmationDialog.vue?vue&type=script&lang=js"
import style0 from "./BetterpayConfirmationDialog.vue?vue&type=style&index=0&id=a8c9969c&prod&lang=scss&scoped=true"
import style1 from "./BetterpayConfirmationDialog.vue?vue&type=style&index=1&id=a8c9969c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c9969c",
  null
  
)

export default component.exports